import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ProjectScenarioConfigDataGridService } from './project-scenario-config-data-grid.service';
import { ColDef } from 'ag-grid-community';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FeatureValidation,
  OrganizationReportingService,
  ProjectsFacade,
  customDecode,
  customEncode,
  decrypt,
  encrypt,
  isFeatureEnabled,
  noWhitespaceValidator,
  showFeatureAlert,
  validateFeatures,
} from '@piqet-angular/data';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ToastrService } from 'ngx-toastr';
import { ActionButtonComponent } from 'libs/ui/src/lib/action-button/action-button.component';
import { GridMyProjectImageComponent } from 'libs/ui/src/lib/grid-my-project-image/grid-my-project-image.component';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { DropdownScenarioConfigComponent } from 'libs/ui/src/lib/dropdown-scenario-config/dropdown-scenario-config.component';
import { ViewportScroller } from '@angular/common';
import { ReportConfigCheckboxComponent } from 'libs/ui/src/lib/report-config-checkbox/report-config-checkbox.component';
import { GridCellRendererComponent } from 'libs/ui/src/lib/grid-cell-renderer/grid-cell-renderer.component';
import { AccessPermissionService, CustomModalService, FeatureCodes } from '@piqet-angular/shared';
import { FileUploadConfig, FileUploadResult, FileUploadComponent } from '@piqet-angular/shared';
import { Subscription, catchError, finalize, lastValueFrom, of } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { InlineTooltipComponent } from 'libs/ui/src/lib/inline-tooltip/inline-tooltip.component';
import { InlineActionButtonComponent } from 'libs/ui/src/lib/inline-action-button/inline-action-button.component';
import { cloneDeep } from 'lodash';
import { guideTourStep15Str } from '@piqet-angular/shared';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-project-scenario-configuration',
  templateUrl: './project-scenario-configuration.component.html',
  styleUrls: ['./project-scenario-configuration.component.scss'],
})
export class ProjectScenarioConfigurationComponent implements OnDestroy, OnInit {
  isExceeded: boolean = false;
  @ViewChild('inputField', { static: false }) inputField!: ElementRef<HTMLInputElement>;
  activeCell: any = null;
  activeCellTwo: any = null;
  activeCellThree: any = null;
  estimatedProductItems: any;
  showEstimatedProductList: any;
  FeatureCodes = FeatureCodes;
  @ViewChild('myFileInput', { static: false }) myFileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('scenarioFileUpload', { static: false }) scenarioFileUpload!: FileUploadComponent;
  isScreenDisabled: any;
  scenarioId: any;
  scenarioConfigForm!: FormGroup;
  scenarioConfigCheckboxes!: FormGroup;
  scenarioConfigData: any;
  fileBase64: any;
  statusList: any;
  activatedRouteProjectId: any;
  selectStatus: any;
  isShowChange = false;
  imageUrl: any;
  scenarioImg: any;
  packagingLevelInfoList: any = [];
  selectedFiles: any;
  scenarioName: any;
  isHideSideBar = true;
  productDepartmentItems: any;
  productFamilyItems: any;
  productClassItems: any;
  columnDefs: any;
  columnDefsContentConfig!: ColDef[];
  productClassId: any;
  productDepartmentId: any;
  productFamilyId: any;
  selectedProductDeptItem: any;
  selectedProductFamilyItem: any;
  selectedProductClassItem: any;
  isUseChecked: any;
  isProjectSpecificChecked: any;
  gridConfig: any = [];
  initailSet: any;
  isImageValid = true;
  frameworkComponents = {
    actionRenderer: ActionButtonComponent,
    GridMyProjectImageComponent: GridMyProjectImageComponent,
    dropdownRendered: DropdownScenarioConfigComponent,
    dropdownOrganization: GridCellRendererComponent,
    orgYearCheckbox: ReportConfigCheckboxComponent,
    inlineTooltipComponent: InlineTooltipComponent,
    inlineActionButtonComponent: InlineActionButtonComponent,
  };
  quantityVal: any = 0;
  densityVal: any = 0;
  productVal: any = 0;
  contentConfig: any;
  menuDataForRouting: any;
  nextIndex: any;
  nextRoute: any;
  eId: any;
  packageScenarioId: any;
  activatedRout: any;
  columnDefsOrgReporting!: ColDef[];
  // headerBtn = '<img class="fa fa-plus" width="60" height="60" src="./assets/icons/add-record.svg">';
  headerBtn = 'Add row';
  headerBtnName = 'orgReportingProcess';
  headerBtnNameForProcess = 'orgReportingProcess';
  headerBtnNameForPackageReporting = 'packagingContentConfig';
  errorNotification: any;
  processColumnDef: any;
  disableSubmit: any;
  configurationYearItems: any;
  productGroupItems: any;
  unitList: any;
  selectedUnit: any;
  editPallet: Subscription;
  deletePallet: Subscription;
  disableButton: boolean = false;

  // File upload configuration for scenario image
  scenarioImageUploadConfig: Partial<FileUploadConfig> = {
    placeholderText: 'Scenario image',
    selectButtonText: 'Select file',
    changeButtonText: 'Change',
    removeButtonText: 'Remove',
    customErrorMessage: 'Only .jpg,.png,.jpeg,.gif file allowed',
    showPreview: true,
    maxFileSize: 5,
  };
  scenarioIdList: any = [];
  deleteOrgYear: Subscription;
  deletePackagingContent: Subscription;
  editPackagingContentSuccess: Subscription;
  editPackagingContent: Subscription;
  subscriptionInline!: Subscription;
  scaleRange!: number;
  xValue!: number;
  yValue!: number;
  deptId: any = null;
  catgId: any = null;
  subCatgId: any = null;
  showAccPalletLabel: boolean = false;
  menuDataObs: Subscription;
  allCategoryData: any;
  allSubCategoryData: any;
  isProjectDefaultSelected = false;
  packagingList = [];
  selectedPackaging: any;
  lastSelectedPackagingLevels: any[] = [];
  guideTourStep15Str = guideTourStep15Str;
  isScenarioNameLimitExceeded: boolean = false;
  showView: boolean = false;
  showEdit: boolean = false;
  isScenarioFeatureDisabled: boolean = false;
  isReportDescriptionExceeded = false;
  isDescriptionExceeded = false;
  isScenarioNameExceeded = false;
  isShortScenarioNameExceeded = false;

  readonly MAX_DESCRIPTION_LENGTH = 600;
  readonly MAX_SCENARIO_NAME_LENGTH = 50;
  readonly MAX_SHORT_SCENARIO_NAME_LENGTH = 15;
  readonly MAX_REPORT_DESCRIPTION_LENGTH = 1200;

  constructor(
    private projectsService: ProjectsService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private toaster: ToastrService,
    private projectScenarioConfigDataGridService: ProjectScenarioConfigDataGridService,
    public projectFacade: ProjectsFacade,
    public sharedService: SharedService,
    private cookieService: CookieService,
    private accessService: AccessPermissionService,
    private router: Router,
    private modal: CustomModalService,
    private organizationReportingService: OrganizationReportingService,
    private swalService: SwalService,
    private viewportScroller: ViewportScroller
  ) {
    this.activatedRout = this.activatedRoute.snapshot.routeConfig?.path;
    this.activatedRoute.queryParams.subscribe(async (values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'];
      this.packageScenarioId = value['packageScenarioId'];
      this.eId = value['eId'] || value['id'];
      this.scenarioImg = '';
      this.imageUrl = '';
      this.removeImage();
      await this.getScenarioConfig();
      this.setFormData();
      this.setCategoryData();
    });

    this.scenarioIdList.push(Number(this.scenarioId), Number(this.packageScenarioId));

    this.scenarioConfigForm = this.formBuilder.group({
      scenarioName: ['', [Validators.required, noWhitespaceValidator, Validators.maxLength(50)]],
      shortScenarioName: [
        '',
        [Validators.required, noWhitespaceValidator, Validators.maxLength(50)],
      ],
      description: ['', [Validators.maxLength(this.MAX_DESCRIPTION_LENGTH)]],
      reportDescription: ['', [Validators.maxLength(this.MAX_REPORT_DESCRIPTION_LENGTH)]],
      status: [null],
    });

    this.scenarioConfigCheckboxes = this.formBuilder.group({
      prodDept: [null],
      prodFamily: [null],
      prodClass: [null],
      unit: [null],
    });
    this.columnDefsContentConfig =
      this.projectScenarioConfigDataGridService.contentConfigurationData();

    this.menuDataObs = this.sharedService.menuData$.subscribe((res: any) => {
      this.menuDataForRouting = res;
    });

    this.projectFacade.getDefalutOrgReportingList$.subscribe((data: any) => {
      this.checkValidation(data);
    });

    this.editPallet = this.sharedService.editPalletData$.subscribe(async (editdata: any) => {
      await this.openPalletView(editdata);
    });

    this.deletePallet = this.projectScenarioConfigDataGridService.deletePalletData$.subscribe(
      async (deletePallet: any) => {
        await this.deletePalletView(deletePallet);
      }
    );

    this.deleteOrgYear = this.projectScenarioConfigDataGridService.deleteOrgYearData$.subscribe(
      async (editdata: any) => {
        await this.deleteOrgReportingData(editdata[0]);
      }
    );

    this.deletePackagingContent =
      this.projectScenarioConfigDataGridService.deletePackageContentConfigData$.subscribe(
        async (editdata: any) => {
          await this.deletePackagingContentData(editdata[0]);
        }
      );

    this.editPackagingContentSuccess =
      this.projectScenarioConfigDataGridService.editPackageContentData$.subscribe(
        async (data: any) => {
          await this.getScenarioConfig();
        }
      );

    this.editPackagingContent =
      this.projectScenarioConfigDataGridService.editPackageContentConfigData$.subscribe(
        async (editdata: any) => {
          this.openPackagingContentModal(editdata);
        }
      );
  }

  async ngOnInit() {
    this.showView = this.accessService.hasPermission('view', '', 'packaging');
    this.showEdit = this.accessService.hasPermission('edit', '', 'packaging');
    this.viewportScroller.scrollToPosition([0, 0]);
    this.isScenarioFeatureDisabled = !isFeatureEnabled(
      FeatureCodes.SCENARIO_SCENARIO_INTERNAL_DATA
    );
    this.setFormData();
    this.subscriptionInline =
      this.projectScenarioConfigDataGridService.inlineEditingObservable$.subscribe(
        (inlineData: any) => {
          this.inlineDataEditing(inlineData);
        }
      );
  }

  triggerScroll(): void {
    window.scroll({ top: 1, behavior: 'smooth' });
  }

  setPackagingLevelInfo(scenarioConfigData: any) {
    scenarioConfigData.packagingLevelInfoList.forEach((el: any) => {
      el['value'] = `./assets/icons/${el.imageName.toLowerCase()}.svg`;
      this.showAccPalletLabel = el.name.toLowerCase() == 'pallet unit';
    });
    const checkPackageLevelDetails = scenarioConfigData.packagingLevelInfoList.map((data: any) => {
      return {
        ...data,
        totalunitsperPallet: data.hasOwnProperty('packageLevelDetails')
          ? data.totalunitsperPallet
          : '',
      };
    });
    this.packagingLevelInfoList = checkPackageLevelDetails;
    if (!!scenarioConfigData.packagingLevelInfo) {
      this.packagingList = scenarioConfigData.packagingLevelInfo?.packagingLevelItems;
      if (scenarioConfigData.packagingLevelInfo?.pgkLevelIds == '') this.selectedPackaging = null;
      if (scenarioConfigData.packagingLevelInfo?.pgkLevelIds != '') {
        const filterPackaging = scenarioConfigData.packagingLevelInfo?.pgkLevelIds
          .split(',')
          .filter((x: any) => x != 2);
        this.selectedPackaging = filterPackaging
          ?.map((x: any) => {
            return Number(x);
          })
          .sort();
        if (this.selectedPackaging?.length == 0) this.selectedPackaging = null;
        this.lastSelectedPackagingLevels = this.selectedPackaging;
        this.disableSelectedPackagingLevels();
      }
    }
    this.columnDefs = cloneDeep(this.columnDefs);
    this.showEdit &&
      (this.columnDefs[5].cellRendererParams['packagingDataList'] = this.packagingLevelInfoList);
  }

  getPackagelevelinfoList() {
    this.projectsService
      .getPackagelevelinfoList(this.scenarioId)
      .pipe(finalize(() => {}))
      .subscribe((res: any) => {
        res.packagingLevelInfoList = res.data['packagingLevelInfoList'];
        const columnDefs: any =
          this.projectScenarioConfigDataGridService.projectScenarioConfigurationData(
            this.activatedRoute
          );
        columnDefs.find((x: any) => x.field == 'totalunitsperPallet').headerName =
          res.data['headerLabel'];
        this.columnDefs = columnDefs;
        delete res.data;
        this.setPackagingLevelInfo(res);
      });
  }

  inlineDataEditing(payload: any) {
    this.projectsService
      .projectInlineupdatePackagelevels(payload.packagelevelinfoId, payload.amount, payload.name)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getPackagelevelinfoList();
        })
      )
      .subscribe(res => {
        if (res.messageType == 0) {
          const columnDefs: any =
            this.projectScenarioConfigDataGridService.projectScenarioConfigurationData(
              this.activatedRoute
            );
          columnDefs.find((x: any) => x.field == 'totalunitsperPallet').headerName = res.message;
          this.columnDefs = columnDefs;
          this.toaster.success(res.message);
        } else {
          this.toaster.error(res.message);
        }
      });
  }

  scroll(magnification: number) {
    this.scaleRange = magnification;
  }

  mouseMove(event: any) {
    this.xValue = event.x;
    this.yValue = event.y;
  }

  onPrev(step: string) {}

  onNextStep(step?: any) {
    if (step == 'step17') {
      const valueToEncrypt = `{ "id": ${this.scenarioConfigData?.scenarioId}, "packageScenarioId": ${this.scenarioConfigData?.packageScenarioId}, "eId": ${this.scenarioConfigData?.scenarioId}}`;
      const encryptedValue = encrypt(valueToEncrypt);
      const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
      // window.scroll({ top: 0, behavior: 'smooth' });
      this.router.navigate(
        [`projects/projects-setting/${customEncode(btoa(encodedValue))}/material-list`],
        {
          queryParams: { param: encryptedValue },
        }
      );
    } else if (step == 'step16') {
      const valueToEncrypt = `{ "id": ${
        this.scenarioConfigData?.scenarioId
      }, "packageScenarioId": ${this.scenarioConfigData?.packageScenarioId + 1}, "eId": ${
        this.scenarioConfigData?.scenarioId
      }}`;
      const encryptedValue = encrypt(valueToEncrypt);
      const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
      this.router.navigate(
        [`projects/projects-setting/${customEncode(btoa(encodedValue))}/material-list`],
        { queryParams: { param: encryptedValue } }
      );
    }
  }

  onNext() {
    // FOR navigating through the project
    const valueToEncrypt = `{ "id": ${this.scenarioId}, "packageScenarioId": ${this.packageScenarioId}, "eId": ${this.eId}}`;
    const encryptedValue = encrypt(valueToEncrypt);
    this.findNextRoute();
    const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
    this.router.navigate(
      [`projects/projects-setting/${customEncode(btoa(encodedValue))}/${this.nextRoute}`],
      {
        queryParams: {
          param: encryptedValue,
        },
      }
    );
  }

  getScenarioIdList() {
    this.activatedRoute.queryParams.subscribe(async (values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'];
      this.packageScenarioId = value['packageScenarioId'];
    });

    this.scenarioIdList = [];
    return this.scenarioIdList.push(Number(this.scenarioId), Number(this.packageScenarioId));
  }

  async getScenarioConfig() {
    const url = location.href.split('/');
    this.activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));
    const response = await this.projectsService.getProjectScenarioConfiguration(
      this.scenarioId,
      this.activatedRouteProjectId,
      1
    );
    this.scenarioConfigData = response.data?.scenarioDetail;
    this.configurationYearItems = this.scenarioConfigData?.configurationYearItems;
    this.contentConfig = this.scenarioConfigData?.productPackageScenarioDetailList;
    this.productGroupItems = this.scenarioConfigData?.productGroupItems;
    this.allCategoryData = this.scenarioConfigData?.productFamilyItems;
    this.allSubCategoryData = this.scenarioConfigData?.productClassItems;
    this.isScreenDisabled = response.data?.isLockProject;
    this.scenarioImg = this.scenarioConfigData?.scenarioImage;
    const urlParts = this.scenarioImg?.split('/');
    // Get the last part of the URL, which should be the filename
    if (urlParts) {
      const fileName = urlParts[urlParts?.length - 1];
      this.selectedFiles = fileName ? fileName : null;
    }
    this.scenarioImg = this.scenarioImg ? (this.scenarioImg += `?` + new Date().getTime()) : '';
    this.statusList = this.scenarioConfigData?.statusItems;
    this.scenarioName = this.scenarioConfigData?.name;
    this.unitList = this.scenarioConfigData?.unitList;
    this.quantityVal = this.scenarioConfigData?.quantity;
    this.densityVal = this.scenarioConfigData?.productDensity;
    this.productVal = this.scenarioConfigData?.functionalUnitsPerProduct;
    this.showEstimatedProductList =
      this.scenarioConfigData?.projectScopePresets == 3 ? true : false;
    if (
      this.showEdit &&
      this.scenarioConfigData.palletConfigurationId > 0 &&
      !this.scenarioConfigData?.palletConfigurationUpdated
    ) {
      this.openPalletView(this.scenarioConfigData);
    }
    if (this.scenarioConfigData?.isUseProjectDefault) {
      this.isUseChecked = this.scenarioConfigData?.isUseProjectDefault;
    } else if (
      !this.scenarioConfigData?.isUseProjectDefault &&
      this.scenarioConfigData?.isScenarioSpecificCategorization
    ) {
      this.isUseChecked = false;
    } else if (
      !this.scenarioConfigData?.isUseProjectDefault &&
      !this.scenarioConfigData?.isScenarioSpecificCategorization
    ) {
      this.isUseChecked = true;
    }
    this.estimatedProductItems = this.scenarioConfigData?.productContentList;
    this.isProjectSpecificChecked = this.scenarioConfigData?.isScenarioSpecificCategorization;
    this.scenarioConfigData?.unitList.map((item: any) => {
      if (item.id == this.scenarioConfigData.unitId) {
        return (this.selectedUnit = item);
      }
    });
    this.statusList.map((item: any) => {
      if (item.id == this.scenarioConfigData.scenarioStatusId) {
        return (this.selectStatus = item);
      }
    });
    this.projectFacade.fillOrgYearData(this.scenarioConfigData?.configurationYears);
    const columnDefs: any =
      this.projectScenarioConfigDataGridService.projectScenarioConfigurationData(
        this.activatedRoute
      );
    columnDefs.find((x: any) => x.field == 'totalunitsperPallet').headerName =
      this.scenarioConfigData.packagingLevelInfo.headerLabel;
    this.columnDefs = columnDefs;
    this.setPackagingLevelInfo(this.scenarioConfigData);
  }

  async saveStatus(event: any) {
    this.getScenarioIdList();
    const response = await this.projectsService.updateProjectScenarioConfiguration(
      this.scenarioIdList,
      'ScenarioStatusId',
      event?.id,
      false
    );
    this.toaster.success(response.data.item2);
  }

  async updateImageForProject() {
    this.getScenarioIdList();
    const payload = {
      scenarioId: this.scenarioId,
      image: this.fileBase64,
      imageName: this.selectedFiles,
    };
    const response = await this.projectsService.updateScenarioConfigurationImage(payload);
    this.toaster.success(response.data?.item2);
    this.getScenarioConfig();
  }

  async onBlur(event: Event | any) {
    const inputElement = event?.target ?? event;
    const value = typeof event === 'string' ? event : inputElement?.value;
    const name = inputElement?.name ?? this.getFieldNameFromControl(inputElement);

    const characterCount = value?.length ?? 0;
    const fieldName = name;

    switch (fieldName) {
      case 'description':
      case 'Description':
        this.isDescriptionExceeded = characterCount > this.MAX_DESCRIPTION_LENGTH;

        if (
          !this.isDescriptionExceeded &&
          !this.scenarioConfigForm.controls['description'].invalid
        ) {
          this.getScenarioIdList();
          const response = await this.projectsService.updateProjectScenarioConfiguration(
            this.scenarioIdList,
            'Description',
            value,
            false
          );

          if (!response.messageType) {
            this.toaster.success(response.data.item2);
          }
        }
        break;

      case 'scenarioName':
      case 'Name':
        this.isScenarioNameExceeded = characterCount > this.MAX_SCENARIO_NAME_LENGTH;

        if (
          !this.isScenarioNameExceeded &&
          !this.scenarioConfigForm.controls['scenarioName'].invalid
        ) {
          this.getScenarioIdList();
          const response = await this.projectsService.updateProjectScenarioConfiguration(
            this.scenarioIdList,
            'Name',
            value,
            false
          );

          if (!response.messageType) {
            this.toaster.success(response.data.item2);
            this.sharedService.accessSideBarData(() => {});
            this.scenarioName = value;
            this.sharedService.scenarioNameFunc(value);
          }
        }
        break;

      case 'shortScenarioName':
      case 'ShortScenarioName':
        this.isShortScenarioNameExceeded = characterCount > this.MAX_SHORT_SCENARIO_NAME_LENGTH;

        if (
          !this.isShortScenarioNameExceeded &&
          !this.scenarioConfigForm.controls['shortScenarioName'].invalid
        ) {
          this.getScenarioIdList();
          const response = await this.projectsService.updateProjectScenarioConfiguration(
            this.scenarioIdList,
            'ShortScenarioName',
            value,
            false
          );

          if (!response.messageType) {
            this.toaster.success(response.data.item2);
          }
        }
        break;
      case 'ReportDescription':
        this.isReportDescriptionExceeded = characterCount > this.MAX_REPORT_DESCRIPTION_LENGTH;

        if (!this.isReportDescriptionExceeded) {
          this.getScenarioIdList();
          const response = await this.projectsService.updateProjectScenarioConfiguration(
            this.scenarioIdList,
            fieldName,
            value,
            false
          );

          if (!response.messageType) {
            this.toaster.success(response.data.item2);
          }
        }
        break;
    }
  }

  onInput(event: Event | any) {
    const inputElement = event?.target || event;
    const value = typeof event === 'string' ? event : inputElement?.value;
    const name = inputElement?.name || this.getFieldNameFromControl(inputElement);

    const characterCount = value?.length ?? 0;
    const fieldName = name;

    switch (fieldName) {
      case 'description':
      case 'Description':
        this.isDescriptionExceeded = characterCount > this.MAX_DESCRIPTION_LENGTH;
        break;
      case 'scenarioName':
        break;
      case 'ReportDescription':
        this.isReportDescriptionExceeded = characterCount > this.MAX_REPORT_DESCRIPTION_LENGTH;
        break;
      case 'Name':
        this.isScenarioNameExceeded = characterCount > this.MAX_SCENARIO_NAME_LENGTH;
        break;
      case 'shortScenarioName':
      case 'ShortScenarioName':
        this.isShortScenarioNameExceeded = characterCount > this.MAX_SHORT_SCENARIO_NAME_LENGTH;
        this.isScenarioNameLimitExceeded = this.isShortScenarioNameExceeded;
        break;
    }
  }

  async onChangeForDropdown(eve: any, name: any) {
    if (eve) {
      switch (name) {
        case 'department':
          this.productFamilyItems = this.allCategoryData?.filter((y: any) => {
            return y.parentRefID == eve?.idLong;
          });
          this.deptId = eve?.idLong;
          this.catgId = null;
          this.subCatgId = null;
          this.productClassItems = [];
          this.scenarioConfigCheckboxes.controls['prodFamily'].reset();
          this.scenarioConfigCheckboxes.controls['prodClass'].reset();
          break;
        case 'category':
          this.productClassItems = this.allSubCategoryData?.filter((y: any) => {
            return y.parentRefID == eve?.idLong;
          });
          this.catgId = eve?.idLong;
          this.subCatgId = null;
          this.scenarioConfigCheckboxes.controls['prodClass'].reset();
          break;
        case 'subCategory':
          this.subCatgId = eve?.idLong;
          break;
      }
      this.updateScenarioInternalDataConfiguration(false);
    }
  }

  setDefaultData(type: string, updateValue?: boolean) {
    switch (type) {
      case 'department':
        this.catgId = null;
        this.deptId = null;
        this.subCatgId = null;
        this.scenarioConfigCheckboxes.controls['prodDept'].reset();
        this.scenarioConfigCheckboxes.controls['prodFamily'].reset();
        this.scenarioConfigCheckboxes.controls['prodClass'].reset();
        this.productFamilyItems = this.scenarioConfigData?.productFamilyItems.filter((y: any) => {
          return y.parentRefID == 0;
        });
        this.productClassItems = this.scenarioConfigData?.productClassItems.filter((y: any) => {
          return y.parentRefID == 0;
        });
        break;
      case 'category':
        this.catgId = null;
        this.subCatgId = null;
        this.productClassItems = this.deptId
          ? []
          : this.scenarioConfigData?.productClassItems.filter((y: any) => {
              return y.parentRefID == 0;
            });
        this.scenarioConfigCheckboxes.controls['prodFamily'].reset();
        this.scenarioConfigCheckboxes.controls['prodClass'].reset();
        break;
      case 'subCategory':
        this.subCatgId = null;
        this.subCatgId = null;
        this.productClassItems =
          !this.deptId && !this.catgId
            ? []
            : this.scenarioConfigData?.productClassItems.filter((y: any) => {
                return y.parentRefID == 0;
              });
        this.scenarioConfigCheckboxes.controls['prodClass'].reset();
        break;
      default:
        break;
    }
    if (updateValue) this.updateScenarioInternalDataConfiguration(false);
  }

  saveScenarioConfig() {
    const payload = {
      id: 0,
      scenarioId: this.scenarioId,
      annualSales: 0,
      annualVolume: 0,
      organizationId: Number(this.cookieService.get('organizationId')),
      SKUDepartmentId: this.deptId,
      SKUCategoryId: this.catgId,
      SKUSubCategoryId: this.subCatgId,
    };
    this.organizationReportingService.addUpdateSKUData(payload).subscribe((x: any) => {
      !x.messageType ? this.toaster.success(x.message) : this.toaster.error(x.message);
    });
  }

  async setCategoryData() {
    this.productDepartmentItems = this.scenarioConfigData?.productDepartmentItems;
    if (this.scenarioConfigData?.skuDepartmentId > 0) {
      this.productFamilyItems = this.scenarioConfigData?.productFamilyItems.filter((y: any) => {
        return y.parentRefID === this.scenarioConfigData?.skuDepartmentId;
      });
    } else {
      this.productFamilyItems = this.scenarioConfigData?.productFamilyItems.filter((y: any) => {
        return y.parentRefID == 0;
      });
    }
    if (this.scenarioConfigData?.skuCategoryId > 0) {
      this.productClassItems = this.scenarioConfigData?.productClassItems.filter((x: any) => {
        return x.parentRefID === this.scenarioConfigData?.skuCategoryId;
      });
    } else if (
      this.scenarioConfigData?.skuCategoryId == 0 &&
      this.scenarioConfigData?.skuDepartmentId == 0
    ) {
      this.productClassItems = this.scenarioConfigData?.productClassItems.filter((y: any) => {
        return y.parentRefID == 0;
      });
    } else {
      this.productClassItems = [];
    }

    this.isProjectDefaultSelected = !this.scenarioConfigData?.isScenarioSpecificCategorization;
    this.selectedProductDeptItem = this.scenarioConfigData?.productDepartmentItems.find(
      (x: any) => x.idLong === this.scenarioConfigData?.skuDepartmentId
    );
    this.selectedProductFamilyItem = this.scenarioConfigData?.productFamilyItems.find(
      (y: any) => y.idLong === this.scenarioConfigData?.skuCategoryId
    );
    this.selectedProductClassItem = this.scenarioConfigData?.productClassItems.find(
      (z: any) => z.idLong === this.scenarioConfigData.skuSubCategoryId
    );
    this.scenarioConfigCheckboxes.patchValue({
      prodFamily: this.selectedProductFamilyItem,
      prodClass: this.selectedProductClassItem,
      prodDept: this.selectedProductDeptItem,
    });
    this.deptId = this.scenarioConfigData?.skuDepartmentId;
    this.catgId = this.scenarioConfigData?.skuCategoryId;
    this.subCatgId = this.scenarioConfigData?.skuSubCategoryId;

    if (this.isProjectDefaultSelected) {
      this.selectedProductDeptItem = this.scenarioConfigData?.productDepartmentItems.find(
        (x: any) => x.id === this.scenarioConfigData?.projectSKUDepartmentId
      );
      this.selectedProductFamilyItem = this.scenarioConfigData?.productFamilyItems.find(
        (y: any) => y.id === this.scenarioConfigData?.projectSKUCategoryId
      );
      this.selectedProductClassItem = this.scenarioConfigData?.productClassItems.find(
        (z: any) => z.id === this.scenarioConfigData.projectSKUSubCategoryId
      );
      this.scenarioConfigCheckboxes.controls['prodFamily'].setValue(null);
      this.scenarioConfigCheckboxes.controls['prodClass'].setValue(null);
      this.scenarioConfigCheckboxes.controls['prodDept'].setValue(null);
    }
  }

  async getAllInternalData() {
    let res = await this.organizationReportingService.getAllInternalDataProductCategoriesList();
    if (!res) return;
    this.productDepartmentItems = res.data?.productDepartmentItems;
    this.allCategoryData = res.data.productFamilyItems;
    this.productFamilyItems = res.data.productFamilyItems;
    this.allSubCategoryData = res.data.productClassItems;
    this.productClassItems = res.data.productClassItems;
    this.setDefaultData('department');
  }

  commonInputSearch(term: string, item: any) {
    return item.name?.toLowerCase().includes(term.toLowerCase());
  }

  removeImage() {
    this.isShowChange = false;
    this.selectedFiles = null;
    this.isImageValid = true;
    this.myFileInput && (this.myFileInput.nativeElement.value = '');
    this.fileBase64 = null;
    this.imageUrl = null;
    this.scenarioImg = null;

    // Reset the file upload component
    if (this.scenarioFileUpload) {
      this.scenarioFileUpload.reset();
    }
  }

  fileChangeEvent(event: any) {
    const reader = new FileReader(); // HTML5 FileReader API
    this.selectedFiles = event.target.files[0].name;
    this.isShowChange = this.selectedFiles ? true : false;
    const file = event.target.files[0];
    const mimeType = file?.type;
    if (
      mimeType?.match(/image\/*/) == null ||
      (mimeType != 'image/png' &&
        mimeType != 'image/jpg' &&
        mimeType != 'image/jpeg' &&
        mimeType != 'image/gif')
    ) {
      this.isImageValid = false;
      return;
    } else {
      if (event.target.files && event.target.files[0]) {
        this.isImageValid = true;
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imageUrl = reader.result;
          this.fileBase64 = this.imageUrl.split(',')[1];
          if (!!this.fileBase64) {
            this.updateImageForProject();
          }
        };
      }
    }
  }

  onScenarioImageSelected(result: FileUploadResult) {
    if (!result.file || !result.isValid) {
      this.removeImage();
      return;
    }

    this.selectedFiles = result.fileName;
    this.isShowChange = !!result.fileName;
    this.imageUrl = result.fileUrl;
    this.fileBase64 = result.fileBase64;
    this.isImageValid = result.isValid;

    if (this.fileBase64) {
      this.updateImageForProject();
    }
  }

  checkValidation(newDefalutOrgReportingList: any): void {
    if (
      newDefalutOrgReportingList.find((x: any) => !x.hasOwnProperty('materialId')) ||
      !newDefalutOrgReportingList.find((x: any) => x.materialId)
    ) {
      this.errorNotification =
        'Please fill all the mandatory information to proceed further in the process.';
    } else {
      const res: any[] = [];
      newDefalutOrgReportingList.map((item: any) => {
        if (!this.errorNotification) {
          const existItem = res.find(
            x => x.materialId == item.materialId && x.amount == item.amount
          );
          if (existItem) {
            this.errorNotification =
              'Filling process is already exist, please select other process to proceed further.';
          } else {
            res.push(item);
            this.errorNotification = '';
          }
        }
      });
    }
    if (newDefalutOrgReportingList?.length === 0) {
      this.errorNotification = '';
    }
  }

  setFormData() {
    if (this.scenarioConfigData?.shortScenarioName?.length > 15) {
      this.isScenarioNameLimitExceeded = true;
    }
    this.scenarioImg = this.scenarioConfigData?.scenarioImage;
    this.scenarioImg = this.scenarioImg ? (this.scenarioImg += `?` + new Date().getTime()) : '';
    this.productClassId = this.scenarioConfigData?.projectProductClassId;
    this.productFamilyId = this.scenarioConfigData?.projectProductFamilyId;
    this.productDepartmentId = this.scenarioConfigData?.projectProductDepartmentId;
    this.scenarioConfigForm.patchValue({
      scenarioName: this.scenarioConfigData?.scenarioName,
      shortScenarioName: this.scenarioConfigData?.shortScenarioName,
      description: this.scenarioConfigData?.description,
      reportDescription: this.scenarioConfigData?.reportDescription,
      status: this.selectStatus,
    });
    this.scenarioConfigCheckboxes.patchValue({ unit: this.selectedUnit });
  }

  findNextRoute() {
    const activeIndex = this.menuDataForRouting.findIndex((x: any) => x.link == this.activatedRout);
    this.nextIndex = activeIndex + 1;
    this.nextRoute = this.menuDataForRouting[this.nextIndex].link;
  }

  change() {
    this.findNextRoute();
    const encodedValue = encodeURIComponent(this.activatedRouteProjectId);
    if (
      this.nextRoute == 'fill-data-list' ||
      this.nextRoute == 'wholesale-data-list' ||
      this.nextRoute == 'retail-list' ||
      this.nextRoute == 'consumer-list'
    ) {
      const valueToEncrypt = `{ "id": ${this.packageScenarioId}, "packageScenarioId": ${this.packageScenarioId}, "eId": ${this.eId}}`;
      const encryptedValue = encrypt(valueToEncrypt);
      this.router.navigate(
        [`projects/projects-setting/${customEncode(btoa(encodedValue))}/${this.nextRoute}`],
        { queryParams: { param: encryptedValue } }
      );
    } else {
      const valueToEncrypt = `{ "id": ${this.scenarioId}, "packageScenarioId": ${this.packageScenarioId}, "eId": ${this.eId}}`;
      const encryptedValue = encrypt(valueToEncrypt);
      this.router.navigate(
        [`projects/projects-setting/${customEncode(btoa(encodedValue))}/${this.nextRoute}`],
        { queryParams: { param: encryptedValue } }
      );
    }
  }

  editRecord(record: any) {
    if (record[0].entityColumnValue != record[4]) {
      this.projectFacade.inlineDataEdit(record[0], 'orgReportingProcess');
    }
  }

  editCell() {
    this.activeCell = true;
  }

  editCellTwo() {
    this.activeCellTwo = true;
  }

  editCellThree() {
    this.activeCellThree = true;
  }

  private getFieldNameFromControl(element: any): string {
    // Try to get the formControlName from the element or its parent
    if (element?.getAttribute) {
      const formControlName =
        element.getAttribute('formcontrolname') ?? element.getAttribute('ng-reflect-name');
      if (formControlName) {
        return formControlName;
      }
    }
    return '';
  }

  async saveMass(event: any) {
    this.activeCell = false;
    const value = typeof event === 'object' ? this.quantityVal : event;

    if (value !== '' && value !== null && value !== undefined) {
      this.quantityVal = parseInt(value.toString(), 10);
      const response = await this.projectsService.editScenarioConfiguration(
        this.packageScenarioId,
        'Quantity',
        this.quantityVal
      );
      this.toaster.success(response.data.item2);
    } else {
      this.quantityVal = 0;
    }
  }

  async saveDensity(event: any) {
    this.activeCellTwo = false;
    const value = typeof event === 'object' ? this.densityVal : event;

    if (value !== '' && value !== null && value !== undefined) {
      this.densityVal = parseInt(value.toString(), 10);
      const response = await this.projectsService.editScenarioConfiguration(
        this.packageScenarioId,
        'ProductDensity',
        this.densityVal
      );
      this.toaster.success(response.data.item2);
    } else {
      this.densityVal = 0;
    }
  }

  async saveProduct(event: any) {
    this.activeCellThree = false;
    const value = typeof event === 'object' ? this.productVal : event;

    if (value !== '' && value !== null && value !== undefined) {
      this.productVal = parseInt(value.toString(), 10);
      const response = await this.projectsService.editScenarioConfiguration(
        this.packageScenarioId,
        'FunctionalUnitsPerProduct',
        this.productVal
      );
      this.toaster.success(response.data.item2);
    } else {
      this.productVal = 0;
    }
  }

  async changeUnit(event: any) {
    const response = await this.projectsService.editScenarioConfiguration(
      this.packageScenarioId,
      'UnitId',
      event.id
    );
    this.scenarioConfigCheckboxes.controls['unit'].setValue(event);
    this.toaster.success(response.data.item2);
  }

  async openPalletView(data: any) {
    let res = (
      await this.projectsService.getPalletConfig(
        this.scenarioConfigData.palletConfigurationId,
        data.scenarioId
      )
    ).data.response;
    this.modal.invoke('projectPalletConfig', {
      initialState: {
        palletData: res,
        palletConfigurationId: this.scenarioConfigData.palletConfigurationId,
      },
      class: 'pallet-view-modal',
    });
    this.modal.ref.content.savePalletView.subscribe((savePallet: any) => {
      this.savePalletData(savePallet);
    });
  }

  deletePalletView(data: any) {
    this.projectsService
      .deleteScenarioPackaginLevelInfo(data.packageLevelInfoId, data.scenarioId)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getScenarioConfig();
          this.modal.close();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  savePalletData(data: any) {
    this.projectsService
      .updatePalletConfig(data)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.sharedService.accessSideBarData(() => {});
          this.getScenarioConfig();
          this.modal.close();
        })
      )
      .subscribe(res => {
        if (res.messageType) {
          this.toaster.error(res.message);
          return;
        }
        this.toaster.success(res.message);
        const openModal = res.data?.palletProgrammingData?.openModal;
        openModal &&
          this.swalService
            .confirm(
              'Pallet configuration',
              'A pallet-level packaging component already exists. Do you want to add an additional pallet-level component'
            )
            .then(confirmed => {
              if (confirmed) {
                const componentData = res.data;
                this.projectsService
                  .AddPalletComponentDataAndReuseData(componentData)
                  .subscribe((res: any) => {
                    res.messageType
                      ? this.toaster.error(res.message)
                      : this.toaster.success(res.message);
                  });
              }
            });
      });
  }

  deleteOrgReportingData(data: any) {
    if (data.productGroupName != 'Select a product') {
      this.projectsService
        .deleteOrgReportingYearData(data.id)
        .pipe(
          catchError((error: any) =>
            of(this.toaster.error('An error occurred. Please try again later.'))
          ),
          finalize(() => {
            this.getScenarioConfig();
          })
        )
        .subscribe(res => {
          res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
        });
    }
  }

  deletePackagingContentData(data: any) {
    this.projectsService
      .deletePackagingContentConfigData(data.id)
      .pipe(
        catchError((error: any) =>
          of(this.toaster.error('An error occurred. Please try again later.'))
        ),
        finalize(() => {
          this.getScenarioConfig();
        })
      )
      .subscribe(res => {
        res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
      });
  }

  async openPackagingContentModal(data: any) {
    let response = (await this.projectsService.openPackagingContentConfigModal(data?.id)).data;
    this.modal.invoke('packagingContentConfig', {
      initialState: {
        packagingContentData: response,
      },
      class: 'pallet-view-modal',
    });
  }

  async refreshSKU() {
    this.getAllInternalData();
  }

  removeScenarioImage(saveData: any) {
    this.projectsService.removeScenarioImage(this.scenarioId).subscribe((res: any) => {
      if (res.messageType) {
        this.toaster.error(res.message);
      } else {
        this.toaster.success(res.message);
        this.removeImage(); // Use the centralized removeImage method
      }
    });
  }

  deleteConfirmation(data: any) {
    this.swalService
      .confirm(
        'Are you sure?',
        'Do you really want to delete this image? This process cannot be undone.'
      )
      .then(confirmed => {
        if (confirmed) {
          this.removeScenarioImage(data);
        } else {
        }
      });
  }

  private validateScenarioFeatures(data: any): string[] {
    const validations: FeatureValidation[] = [
      {
        condition:
          !data.isProjectDefault && (data.departmentId || data.categoryId || data.subCategoryId),
        featureCode: FeatureCodes.SCENARIO_SCENARIO_INTERNAL_DATA,
        featureName: 'Scenario Internal Data Configuration',
      },
      {
        condition:
          data.isScenarioSpecificCategorization &&
          (data.departmentId || data.categoryId || data.subCategoryId),
        featureCode: FeatureCodes.SCENARIO_SCENARIO_INTERNAL_DATA,
        featureName: 'Organization Packaging Footprint',
      },
    ];

    return validateFeatures(validations, isFeatureEnabled);
  }

  async updateScenarioInternalDataConfiguration(changeOption: boolean) {
    if (changeOption) {
      this.isProjectDefaultSelected = !this.isProjectDefaultSelected;
      this.setDefaultData('department');
    }
    var data: any = {
      scenarioIds: this.scenarioIdList,
      isProjectDefault: this.isProjectDefaultSelected,
      departmentId: this.deptId,
      categoryId: this.catgId,
      subCategoryId: this.subCatgId,
    };

    const missingFeatures = this.validateScenarioFeatures(data);

    if (missingFeatures.length > 0) {
      showFeatureAlert(missingFeatures, this.swalService);
      // Reset to previous state
      this.isProjectDefaultSelected = !this.isProjectDefaultSelected;
      return;
    }
    var res: any = await lastValueFrom(this.projectsService.updateScenarioInternalDataConfig(data));
    res.messageType ? this.toaster.error(res.message) : this.toaster.success(res.message);
  }

  async addUpdatePackagingLevels(event: any) {
    var res: any = await lastValueFrom(
      this.projectsService.savePackagingLevel(this.selectedPackaging.join(','), this.scenarioId)
    );
    if (!this.lastSelectedPackagingLevels?.includes(5) && this.selectedPackaging?.includes(5)) {
      this.scenarioConfigData.palletConfigurationId = parseFloat(res.data.value || '0');
      this.openPalletView(this.scenarioConfigData);
    }
    if (!res.messageType) {
      this.lastSelectedPackagingLevels = this.selectedPackaging.sort();
      this.toaster.success(res.message || 'Packaging levels updated successfully');
      this.getPackagelevelinfoList();
    } else {
      this.toaster.error(res.message);
      this.selectedPackaging = this.lastSelectedPackagingLevels;
    }
    this.disableSelectedPackagingLevels();
  }

  disableSelectedPackagingLevels() {
    this.packagingList?.forEach((x: any) => {
      x.selected = this.selectedPackaging?.includes(x.id) ? true : false;
    });
  }

  ngOnDestroy() {
    this.editPallet.unsubscribe();
    this.deleteOrgYear.unsubscribe();
    this.editPackagingContentSuccess.unsubscribe();
    this.editPackagingContent.unsubscribe();
    this.deletePackagingContent.unsubscribe();
    this.projectFacade.orgReportingFailure('');
    this.deletePallet.unsubscribe();
    this.menuDataObs.unsubscribe();
    this.subscriptionInline.unsubscribe();
    this.isScenarioNameLimitExceeded = false;
  }
}
